import { render, staticRenderFns } from "./WidgetTournamentSettings.vue?vue&type=template&id=4bd0b8d4&scoped=true&"
import script from "./WidgetTournamentSettings.vue?vue&type=script&lang=js&"
export * from "./WidgetTournamentSettings.vue?vue&type=script&lang=js&"
import style0 from "./WidgetTournamentSettings.vue?vue&type=style&index=0&id=4bd0b8d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd0b8d4",
  null
  
)

export default component.exports